import { configureStore, combineReducers } from "@reduxjs/toolkit";
import calculatorReducer from "./calculator_slices/tiles-calculator";
import stepsReducer from "./calculator_slices/steps-slice";
import homeDataReducer from "./home_data_slice/home_data_slice";
import headerReducer from "./header_data_slice/header_data_slice";
import footerReducer from "./footer_data_slice/footer_data_slice";
import { createWrapper, HYDRATE } from "next-redux-wrapper";
import simpoloHistoryReducer from "./corporate_slices/simpolo_history_slice";
import aboutUsReducer from "./corporate_slices/about_us_slice";
import chairmanReducer from "./corporate_slices/chairman_slice";
import foundationReducer from "./corporate_slices/foundation_slice";
import foundationDetailsReducer from "./corporate_slices/foundation_details_slice";
import sustainabilityReducer from "./corporate_slices/sustainability_slice";
import galleryReducer from "./corporate_slices/gallery_slice";
import careerReducer from "./corporate_slices/career_slice";
import newsAndMediaReducer from "./corporate_slices/news_and_media_slice";
import newsDetailsReducer from "./corporate_slices/news_details_slice";
import collectionReducer from "./collection_slices/collection_data_slice";
import collectionLandingReducer from "./collection_slices/collection_landing_slice";
import productReducer from "./product_slices/product_data_slice";
import productDetailsReducer from "./product_slices/product_details_slice";
import bathwareReducer from "./bathware_slices/bathware_data_slice";
import bathwareListReducer from "./bathware_slices/bathware_list_slice";
import bathwareProductDetailsReducer from "./bathware_slices/bathware_product_details_slice";
import projectReducer from "./project_slices/project_slice";
import projectListReducer from "./project_slices/project_list_slice";
import projectDetailsReducer from "./project_slices/project_details_slice";
import becomeADealerReducer from "./become_a_dealer_slices/become_a_dealer_sliece";
import customerComplaintsReducer from "./customer_complaints_slices/customer_complaints_slice";
import certificationReducer from "./solution_slices/certification_slice";
import technicalVidesReducer from "./solution_slices/technical_videos_slice";
import installationGuideReducer from "./solution_slices/installation_guide_slice";
import technicalAreaReducer from "./solution_slices/technical_area_slice";
import technicalGuideReducer from "./solution_slices/technical_guide_slice";
import selectionGuideReducer from "./solution_slices/selection_guide_slice";
import globalEnquiryDropdownReducer from "./enquiry_form_slices/global_enquiry_dropdown_data_slice";
import prodcutGalleryReducer from "./product_gallery_slice/product_gallery_slice";
import brandKitReducer from "./brand_kit_slice/brand_kit_slice";
import whereToBuyReducer from "./where_to_buy_slices/where_to_buy_slice";
import dealerLocationsReducer from "./where_to_buy_slices/dealer_locations_slice";
import catalogueReducer from "./catalogue_slice/catalogue_data_slice";
import searchResultReducer from "./search_result_slice/search_result_slice";
import favouritesReducer from "./favourites_slice/favourites_slice";
import profileReducer from "./profile_slice";
import professionalPageDataReducer from "./professional_slices/professional_page_slice";
import professionalDetailsReducer from "./professional_slices/professional_details_slice";
import tilesInternalSlugReducer from "./tiles_internal_slug_slices/tiles_slug_slices";
// Combine all reducers
const combinedReducer = combineReducers({
  calculator: calculatorReducer,
  stepsReducer: stepsReducer,
  homeDataReducer: homeDataReducer,
  header: headerReducer,
  footer: footerReducer,
  simpoloHistory: simpoloHistoryReducer,
  aboutUsData: aboutUsReducer,
  chairmanData: chairmanReducer,
  foundationData: foundationReducer,
  foundationDetailsData: foundationDetailsReducer,
  sustainabilityData: sustainabilityReducer,
  galleryData: galleryReducer,
  careerData: careerReducer,
  newsAndMediaData: newsAndMediaReducer,
  newsDetailsData: newsDetailsReducer,
  collectionData: collectionReducer,
  collectionLandingData: collectionLandingReducer,
  productData: productReducer,
  productDetailsData: productDetailsReducer,
  bathwareData: bathwareReducer,
  bathwareListData: bathwareListReducer,
  bathwareProductDetailsData: bathwareProductDetailsReducer,
  projectData: projectReducer,
  projectListData: projectListReducer,
  projectDetailsData: projectDetailsReducer,
  becomeADealerData: becomeADealerReducer,
  customerComplaintsData: customerComplaintsReducer,
  certificationData: certificationReducer,
  technicalVideosData: technicalVidesReducer,
  installationGuideData: installationGuideReducer,
  technicalAreaData: technicalAreaReducer,
  technicalGuideData: technicalGuideReducer,
  selectionGuideData: selectionGuideReducer,
  globalEnquiryDropdownData: globalEnquiryDropdownReducer,
  prodcutGalleryData: prodcutGalleryReducer,
  brandKitData: brandKitReducer,
  whereToBuyData: whereToBuyReducer,
  dealerLocationsData: dealerLocationsReducer,
  catalogueData: catalogueReducer,
  searchResultData: searchResultReducer,
  favouritesData: favouritesReducer,
  profileData: profileReducer,
  professionalPageData: professionalPageDataReducer,
  professionalDetailsData: professionalDetailsReducer,
  tilesSlugData : tilesInternalSlugReducer,
});

const reducer = (state, action) => {
  if (action.type === HYDRATE) {
    const nextState = {
      ...state, // use previous state
      ...action.payload, // apply delta from hydration
    };
    if (state.calculator) nextState.calculator = state.calculator; // preserve specific client state if necessary
    return nextState;
  } else {
    return combinedReducer(state, action);
  }
};

export const store = configureStore({
  reducer,
});

const makeStore = () => store;
export const wrapper = createWrapper(makeStore);
